import PropTypes from 'prop-types';
import classNames from 'classnames';
import MediaQuery from 'react-responsive';
import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import {
  MQ_MOBILE_MIN_WIDTH,
  MQ_SMALL_MOBILE_MAX_WIDTH
} from '@spotahome/marketplace-common/src/constants';

import './FiltersHeader.scss';

const FiltersHeader = ({ totalResults, onHandleFiltersToggle }) => {
  const closeFiltersText = trans('search.filters.view_close_filters', {
    nResults: totalResults
  });

  const classes = classNames(
    'filter-header',
    'filter-header--expanded',
    'filter-header--expanded--new-layout'
  );

  const buttonContainerClasses = classNames('filter-header__button-container');

  const resultButtonClasses = classNames(
    'filter-header__results-button',
    'ga-search-form-more-filters'
  );

  return (
    <div className={classes}>
      <div className={buttonContainerClasses}>
        <Button
          className={resultButtonClasses}
          onClick={onHandleFiltersToggle}
          dataTest="more-filters-button"
          color="secondary"
          renderContent={() => (
            <>
              <MediaQuery minWidth={MQ_MOBILE_MIN_WIDTH}>
                {closeFiltersText}
              </MediaQuery>
              <MediaQuery maxWidth={MQ_SMALL_MOBILE_MAX_WIDTH}>
                {closeFiltersText}
              </MediaQuery>
            </>
          )}
        />
      </div>
    </div>
  );
};

FiltersHeader.propTypes = {
  totalResults: PropTypes.number.isRequired,
  onHandleFiltersToggle: PropTypes.func.isRequired
};

export default FiltersHeader;
